<template>
    <div class="sign-up-form" style="height:100%">
      <!-- <Logo :isTitle="true" :width="200" :color="'green'" :clickable="true" /> -->
      <v-toolbar-title class="taption-logo no-nav">
      <router-link :to="getLogoUrl">
        <img alt="logo" :src='"../assets/images/logo_green_title.webp"' style="height:52px; width: 200px; display: block"/>
      </router-link>
      </v-toolbar-title>
      <section ref="signupform" class="authentication-form">
        <v-fade-transition>
          <div ref="signupcontainer" class="signup-container">
            <h1 class="title text-center">
              <span>{{$lang.login.create_free_account}}</span>
            </h1>
            <div class="signup-card card">
              <img width="50px" src="../assets/logo.png"/>
              <v-form ref="form" class="theme-form">
                <div class="field">
                  <v-text-field
                    required
                    class="inputs"
                    v-model="firstName"
                    :placeholder="$lang.login.name"
                    :disabled="isSignupLoading"
                    :rules="nameRules"
                    autocomplete="name"
                    solo
                    flat
                    dense
                  ></v-text-field>
                </div>
  
                <div class="field">
                  <v-text-field
                    required
                    v-model="email"
                    :placeholder="$lang.login.email_address"
                    :disabled="isSignupLoading"
                    :rules="emailRules"
                    autocomplete="email"
                    solo
                    flat
                    dense
                  ></v-text-field>
                </div>
  
                <div class="field">
                  <v-text-field
                    type="password"
                    v-model="password"
                    :placeholder="$lang.login.password"
                    :rules="passwordRules"
                    required
                    :disabled="isSignupLoading"
                    password-reveal
                    solo
                    flat
                    dense
                  ></v-text-field>
                </div>

                <div class="field">
                  <v-text-field
                    type="password"
                    v-model="confirmPassword"
                    :placeholder="$lang.login.confirm_password"
                    required
                    :rules="confirmPasswordRules"
                    :disabled="isSignupLoading"
                    password-reveal
                    solo
                    flat
                    dense
                  ></v-text-field>
                </div>
  
                <v-card class="none" v-show="!!loginError" height="10px" width="100%">
                  <span class="error-message">{{ loginError }}</span>
                </v-card>
  
                <v-btn
                  class="button round signup"
                  color="success"
                  :loading="isSignupLoading"
                  :disabled="isSignupLoading"
                  type="button"
                  @click="signUp"
                >{{$lang.login.create_account}}</v-btn>
  
                <p>
                  {{$lang.login.or_go_back_to}}
                  <router-link to="login">{{$lang.login.login.toLowerCase()}}</router-link>
                </p>
              </v-form>
            </div>
          </div>
        </v-fade-transition>
      </section>
    </div>
  </template>
  
  <script>
  /* global tap_google */
  /* global tap_microsoft */
import textHelper from "@/utils/textManager";
import userService from '../connections/user.service';
  export default {
    name: "SignupPage",
    data() {
      return {
        isSignupLoading: false,
        email: "",
        confirmPassword:'',
        emailRules: [],
        password: "",
        passwordRules: [],
        firstName: "",
        lastName: "",
        loginError: "",
        nameRules: [],
        confirmPasswordRules:[]
      };
    },
    methods: {
      signUp: function() {
        const me = this;
        if (me.isFormValid) {
          me.isSignupLoading = true;
          userService.getUserSignupPromise(me.email, me.password)
            .then(
              function() {
                userService.sendEmailVerification();
                return userService.createIdToken(true)
              },
              function(err) {
                me.loginError = me.$lang.error[err.code];
                return Promise.resolve(false);
              }
            ).then(function(result){
              if(result){
                return userService.updateUser({displayName: me.firstName});
              }
              else{
                return Promise.resolve(false);
              }
            }).then(function(result){
              if(result){
                userService.getSignOutPromise();
                return Promise.resolve(true);
              }
              else{
                return Promise.resolve(false);
              }
            }).then(
            function (result) {
              if(result){
                me.$router.push({ name: "login" });

                let message = {
                    title: me.$lang.login.check_to_verify_header,
                    body: me.$lang.login.check_to_verify + '<div class="fading-line"></div>'
                };

                me.$dialog.alert(message,{
                    customClass: 'taption-dialog alert success-dialog single',
                    okText: me.$lang.common.ok,
                    html: true
                });
              }
                
                if(process.env.VUE_APP_MODE && process.env.VUE_APP_MODE === 'production'){
                 // gtag('event', 'register');
                 tap_google('signup');
                 tap_microsoft('signup');
                }
            })
            .finally(function() {
              me.isSignupLoading = false;
             // window.dablena('track', 'CompleteRegistration');
            });
        }
      }
    },
    computed: {
      isFormValid() {
        const me = this;
        return me.$refs.form.validate();
      },
      getLogoUrl() {
        const language =  textHelper.getDisplayLanguage();
        if(language === 'zh'){
            return { name: "taptiontw" };
        }
        else if(language === 'zh-CN'){
            return { name: "taptioncn" };
        }
        else if(language === 'en-US' || language === 'en'){
            return { name: "taption" };
        }
        else{
            return { name: `taption${language}` };
        }
        }
    },
    mounted() {
      const me = this;
      me.$refs.signupform.addEventListener('keyup', function(event) {
        if (event.keyCode === 13) { 
          me.signUp();
        }
      });
  
      me.emailRules = [
        v =>
          !!v ||
          me.$lang.payment.required_field.format(me.$lang.login.email_address),
        v => /.+@.+\..+/.test(v) || me.$lang.error.email_must_be_valid,
        v => (v && v.length <= 100) || me.$lang.error.must_be_less_than.format(100)
      ];
  
      me.passwordRules = [
        v => !!v || me.$lang.payment.required_field.format(me.$lang.login.password),
        v => (v && v.length >= 8) || me.$lang.error.must_be_more_than.format(8),
        v => (v && v.length <= 50) || me.$lang.error.must_be_less_than.format(50)
      ];
  
      me.nameRules = [
        v => !!v || me.$lang.payment.required_field.format(me.$lang.login.name),
        v => (v && v.length <= 50) || me.$lang.error.must_be_less_than.format(50)
      ];

    me.confirmPasswordRules = [
        (value) => !!value || me.$lang.error.confirm_password_desc,
        (value) =>
          value === me.password || me.$lang.error.confirm_password_not_match,
    ];
  
      setTimeout(function() {
        me.$refs.signupcontainer.classList.add("show");
      }, 100);
    }
  };
  </script>
  
  <style scoped>
    .authentication-form{
    justify-content: center;
    display: flex;
    align-items: center;
    margin-top: 0px !important;
    padding-top:0px!important;
    
  }

  .login-container{
    height:inherit;
  }

  .authentication-form .signup-card {
    -webkit-box-shadow: 0 1px 4px rgba(1, 1, 1, .15);
    box-shadow: 0 1px 4px rgba(1, 1, 1, .15);
    cursor: default !important;
    height: 470px;
    border: 0;
    padding: 5px 50px 50px;
    width: 500px;
    margin: 0 auto;
    border-top: 3px solid #1ad7dd;
    border-radius: 0px 0px 10px 10px;
    font-size: 14px;
}

  .logo {
    position: absolute;
      top: 42px;
      left: 75px;
  }
  .authentication-form a{
    text-decoration: underline !important;
    font-size: 14px;
    color: #2fc59f !important;
}
button{
    border-radius: 20px;
}
.error-message{
    color:red;
}

  
  </style>
  
  
  <style>
  h2 {
    font-weight: 400;
  }
  .signup-container {
    -webkit-transition: all 200ms ease-in;
    -moz-transition: all 200ms ease-in;
    -o-transition: all 200ms ease-in;
    transition: all 200ms ease-in;
    opacity: 0;
    height: inherit;
  }
  .signup-container.show {
    opacity: 1;
  }
  
  .authentication-form {
    height:inherit;
  }
  
  .authentication-form a:hover{
    color: #007bff!important;
  }
  
  .authentication-form .signup-card {
    box-shadow: 0 1px 10px rgba(1, 1, 1, 0.25);
    cursor: default !important;
  
    border-radius: 10px;
    height: 450px;
  }
  .authentication-form p {
    margin: 0px!important;
    text-align: left;
  }
  .signup-header {
    margin-top: 50px;
  }
  
  .signup-form {
    margin: 0 auto;
    width: 400px;
    height: auto;
    padding: 30px;
    border-radius: 0px;
    background: whitesmoke;
    border: 0px solid #6eb7e7;
    box-shadow: 0 5px 12px rgba(1, 1, 1, 0.15);
    -webkit-box-shadow: 0 5px 12px rgba(1, 1, 1, 0.15);
  }
  
  .v-btn.round.signup {
    width: 400px ;
    height: 45px !important;
    margin: 20px 0px 20px 0px !important;
  }
  
  .v-card.none {
    border: 0 !important;
    box-shadow: none !important;
  }
  .signup-card input{
  margin-bottom:0px;
}
.signup-card img{
  margin:10px 0px;
}
  </style>
  